module.exports = __webpack_public_path__ + "static/media/home-alt.1152c826.svg";